import React, { ReactNode } from 'react';

import ChevronRight from '../../styles/assets/icons/ChevronRight';
import styles from './infoPillButton.module.scss';

type InfoPillButtonProps = {
  children: ReactNode;
  onClick?: () => void;
  className?: string;
};

const InfoPillButton: React.FC<InfoPillButtonProps> = ({ children, ...props }) => (
  <button
    className={`${styles.infoPillButton} ${props.className}`}
    data-testid="info-pill-button"
    onClick={props.onClick}
    type="button"
    data-palette="InfoPillButton">
    {children}
    <ChevronRight width={12} height={12} />
  </button>
);

export default InfoPillButton;
